var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download-file",on:{"click":_vm.downloadFile}},[(_vm.isIE)?_vm._t("default"):_c('a',{staticClass:"download-file--a",attrs:{"href":_vm.downloadLink,"download":""}},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }